<template>
    <section id="container">
      <router-view/>
      <div class="bg"></div>
    </section>
</template>

<script>

import {Api} from '@/core/api.js';
const api = new Api();

export default {
    components: { },
    methods: {
    },
    created() {
      
    }
}
</script>

<style lang="scss" scoped>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  #container {
    width: 100%;
    margin: 0 auto;
  }
  .bg {
    position: fixed;
    bottom: 0;
    left: 0;
    background: url('/img/bg3.png');
    background-position: center bottom -50px;
    background-repeat: repeat-x;
    background-size: 1200px;
    width: 100%;
    height: 100%;
    z-index: -1;
  }


</style>

<style lang="scss">
html {
    overflow: auto !important;
}
</style>